/**
 * What the album Tracks tab says when no rows are on screen (Paul McGowan,
 * Oct 26 2026: "This album is not available for streaming." while the album was
 * playing). "Not available" only with a present rights verdict (#11212); a failed
 * or empty fetch is "couldn't load" with a retry; anything in flight is "loading".
 */
export type AlbumTracksEmptyKind = 'loading' | 'local_empty' | 'not_streamable' | 'load_failed';

export function albumTracksEmptyState(args: {
  mirrorLoading: boolean;
  isLocal: boolean;
  qobuzAlbumId: string | null;
  qobuzCatalogLoaded: boolean;
  streamingCatalogUnavailable: boolean;
}): { kind: AlbumTracksEmptyKind; messageKey: string; canRetry: boolean } {
  if (args.mirrorLoading) return { kind: 'loading', messageKey: 'album.tracks.loading', canRetry: false };
  if (args.isLocal) return { kind: 'local_empty', messageKey: 'album.tracks.localEmpty', canRetry: false };
  if (args.streamingCatalogUnavailable) {
    return { kind: 'not_streamable', messageKey: 'album.tracks.notStreamable', canRetry: false };
  }
  if (args.qobuzAlbumId && !args.qobuzCatalogLoaded) {
    return { kind: 'loading', messageKey: 'album.tracks.loading', canRetry: false };
  }
  return { kind: 'load_failed', messageKey: 'album.tracks.loadFailed', canRetry: !!args.qobuzAlbumId };
}
